// Global site tag (gtag.js) - Google Analytics
let theWindow = <any>window;
theWindow.dataLayer = theWindow.dataLayer || [];
function gtag(a, b){theWindow.dataLayer.push([a, b]);}

gtag('js', new Date());
gtag('config', 'UA-111501505-1');

